import { HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';

export abstract class HttpAbstract {

  public handleError(error: HttpErrorResponse | string) {
    // handleError puede correr dos veces (ErrorInterceptor + catchError del servicio).
    // Si ya recibimos un mensaje procesado (string), lo dejamos pasar sin re-procesar,
    // asi no se degrada a "Error desconocido".
    if (typeof error === 'string') {
      return throwError(error);
    }
    let message = '';
    // El backend (ResponseJson) manda el detalle de los errores !=200 en este header
    const headerMessage = error.headers && error.headers.get('response-error-message');
    if (error.status === 0) {
      console.error('Error de red: no se pudo conectar con el servidor');
      message = 'Error de conexion: verifique su red e intente nuevamente.';
    } else if (error.error instanceof ErrorEvent) {
      console.error(`An error occurred ${error.error.message}`);
      message = error.error.message;
    } else if (headerMessage) {
      console.error(`Server returned code: ${error.status}, message: ${headerMessage}`);
      message = headerMessage;
    } else if (error.error != null) {
      console.error(`Server returned code: ${error.status}, body was: ${JSON.stringify(error.error)}`);
      message = error.error.message || error.error.detail || error.error.error || 'Error desconocido: por favor, intente la operación más tarde.';
    } else {
      console.error(`Server returned code: ${error.status}, body was: ${JSON.stringify(error.message)}`);
      message = 'Error desconocido: por favor, intente la operación más tarde.';
    }
    return throwError(message);
  }

}
